import { AMP_ADD_TO_CART_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import WaterMark from "component/design-system/WaterMark";
import AddToCartContainer from "component/product/V2/add-to-cart/AddToCartContainer";
import { RootState } from "interfaces/generics.type";
import PriceRange from "modules/components/prices/range-price/PriceRange";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import PAImage from "../../../../component/design-system/images/PAImage";
import { isEmpty } from "../../../../util/lodash/isEmpty";
import { getThumbnailSrcV2 } from "../../../../util/product/getThumbmailSrc";
import Price from "../../prices/price/Price";
import WasPrice from "../../prices/was-price/WasPrice";
import styles from "../product-cards.module.scss";

interface IHorizontalProductCardProps {
  product: ICompactProduct;
  isSmallCard?: boolean;
  cardClickCallback?: () => void;
  addToCartClickCallback?: () => void;
}

function HorizontalProductCard(props: IHorizontalProductCardProps) {
  const {
    product, isSmallCard = false, cardClickCallback, addToCartClickCallback,
  } = props;
  const {
    sku, fitment, minimumPrice, maximumPrice, canonicalUrl, manufacturerSmallImageUrl,
    manufacturer, extendedDescription, outOfStock, description, longDescription, partNumber,
  } = product;
  const { pickUpAvailable, shippingAvailable } = product;
  const { savedItems } = useSelector((store: RootState) => store.shoppingCart);
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isSavedItem = savedItems.some((element) => element.sku === sku);

  // const handleSaveItemForLater = (event) => {
  //   event.preventDefault();
  //   const saveOrRemove = !isSavedItem;
  //   const callback = null;

  //   dispatch(saveItem(
  //     product,
  //     selectedVehicle,
  //     callback,
  //     saveOrRemove ? fitment === VEHICLE_FITMENT.UNIVERSAL : true,
  //     saveOrRemove ? 1 : 0,
  //   ));
  // };

  function clickHandler() {
    if (cardClickCallback) {
      cardClickCallback();
    }
  }

  const renderPriceElement = () => (
    <div className={`${styles.price_element} ${styles.horizontal_price}`}>
      {
        minimumPrice && maximumPrice
          ? <PriceRange minimumPrice={minimumPrice} maximumPrice={maximumPrice} /> : (
            <>
              <Price product={product} />
              <HideIf show={!businessCustomer}>
                <WasPrice product={product} />
              </HideIf>
            </>
          )
      }
    </div>
  );
  const { href, asPath } = getHrefAndPath({ asPath: canonicalUrl });

  // const brandLogo = (
  //   <PAImage
  //     src={getRelativeImagePath(manufacturerSmallImageUrl)}
  //     width={100}
  //     height={27}
  //     alt={manufacturer}
  //   />
  // );

  const hasExtendedDesc = !isEmpty(extendedDescription)
    && !isEmpty(extendedDescription.description);

  const htmlDetails = (
    <div className={styles.horizontal_product_container}>

      <div className={styles.image_wrapper}>
        {outOfStock && (
          <WaterMark label={t("OUT OF STOCK")} fontSize={5} />
        )}

        <PAImage
          src={getThumbnailSrcV2(product)}
          width={110}
          height={110}
          containerClass={styles.item_image}
          lazyLoad={false}
        />
      </div>
      <div>
        <HideIf show={!isSmallCard}>
          {renderPriceElement()}
          <div className={styles.card_actions}>
            <div
              className={`${styles.media_body} text-right`}
              style={{ width: "auto", display: "flex", gap: "calc(0.5 * var(--safari-root-font, 10px))" }}
              onClick={(event) => {
                event.preventDefault();
                if (addToCartClickCallback) {
                  addToCartClickCallback();
                }
              }}
            >
              <AddToCartContainer
                product={product}
                addingToCartLocation={AMP_ADD_TO_CART_LOCATIONS.HORIZONTAL_PRODUCT_CARD}
                showSaveButton={false}
                quantityClass={styles.quantity_class}
                classActionContainer={`${styles.class_action_container} ${styles.horizontal_action_container}`}
                {...{
                  pickUpAvailable,
                  shippingAvailable,
                }}
                showLabel={false}
              />
            </div>
          </div>
        </HideIf>
      </div>
    </div>
  );

  return (
    <div className={`${styles.product_item_compact_horizontal} media`}>

      <Link href={href} as={asPath} className={styles.link_decoration} onClick={clickHandler}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}

        <span className={`${styles.item_link}`}>
          {!hasExtendedDesc && htmlDetails}
        </span>

        <div className="media m-0 d-flex align-items-center">

          {/* <div className={styles.media_left} style={{ paddingLeft: "calc(2 * var(--safari-root-font, 10px))" }}>{brandLogo}</div> */}

        </div>

        <div className={styles.item_description_2}>
          {longDescription || description}
        </div>

        {/* <span className={styles.item_manufacturer}>{manufacturer}</span>

        <HideIf show={partNumber}>
          <div>

            <span className={styles.item_part_label}>Part #: </span>

            <span>{partNumber}</span>
          </div>
        </HideIf> */}

      </Link>
    </div>
  );
}

export default HorizontalProductCard;
